import { faker } from '@faker-js/faker'

import {
  DailyBudget,
  ExposureAvailability,
  Objective,
  ObjectiveType,
  ResponseGetOrganicAds,
  TargetCountry,
} from '../../contracts/organic-ad'

function generateRandomObjective<Type extends ObjectiveType>({
  objectiveType,
}: {
  objectiveType: Type
}): Objective<Type> {
  return {
    id: faker.number.int({ min: 10000, max: 99999 }),
    name: faker.lorem.sentence(),
    type: objectiveType,
    targetCountry: faker.helpers.arrayElement(Object.values(TargetCountry)),
  }
}

function generateRandomDailyBudget() {
  return {
    date: faker.date.recent().toISOString(),
    amount: faker.helpers.arrayElement([faker.number.int(), null]),
    spendingAmount: faker.number.int(),
  }
}

export function generateRandomOrganicAd<Type extends ObjectiveType>({
  objectiveType,
  dailyBudget = generateRandomDailyBudget(),
  exposureAvailability = faker.helpers.arrayElement(Object.values(ExposureAvailability)),
}: {
  objectiveType: Type
  dailyBudget?: DailyBudget
  exposureAvailability?: ExposureAvailability
}) {
  return {
    objective: generateRandomObjective<Type>({ objectiveType }),
    hospitalId: faker.number.int(),
    dailyBudget,
    exposureAvailability,
  }
}

export function createRandomResponseGetOrganicAds<Type extends ObjectiveType>({
  objectiveType,
  totalElementNumber = 1,
  pageSize = 20,
}: {
  objectiveType: Type
  totalElementNumber?: number
  pageSize?: number
}): ResponseGetOrganicAds<Type> {
  const totalPageNumber = Math.ceil(totalElementNumber / pageSize)
  const currentPageIndex = 0
  const isLastPage = currentPageIndex === totalPageNumber - 1

  const contents = Array.from({ length: totalElementNumber }, () => generateRandomOrganicAd<Type>({ objectiveType }))

  return {
    totalPageNumber,
    currentPageIndex,
    pageSize,
    isLastPage,
    totalElementNumber,
    contents,
  }
}
